module.exports = __webpack_public_path__ + "img/ac80c6f547e34452da329d7471816116.png";